module.exports = __webpack_public_path__ + "e9cab0988b93c9301482e5b5e205a99d.MP3";